import { c as _c } from "react/compiler-runtime";
import { STACK_ERROR_SX } from "@components/common/dialog/dialog-constants";
import { TEAM_AVATAR_BACKGROUND } from "@styles/common-colors";
import { GroupAutoComplete } from "@components/common/group-autocomplete/group-autocomplete";
import { LabelWithHelp } from "@components/common/label-with-help";
import { EMAILS_ONLY_PLACEHOLDER, MembersAutocomplete } from "@components/common/members-autocomplete/members-autocomplete";
import { SphereAvatar } from "@components/header/sphere-avatar";
import { CompanyRoleAutoComplete } from "@components/role/role-autocomplete/company-role-autocomplete";
import { Text, TextField, TeamIcon } from "@flat-ui";
import { Box, Grid, Stack } from "@mui-wrapper";
import { MAX_DESCRIPTION_CHARACTERS, MAX_NAME_CHARACTERS } from "@pages/members/teams/create-team-dialog";
import { TEAM_DISPLAY_NAME, TEAMS_DISPLAY_NAME } from "@src/constants/team-constants";
import { capitalizeFirstLetter } from "@utils/string-utils";
import { isValidTeamName } from "@utils/team-utils";
import { getAssignableWorkspaceRoles } from "@utils/workspace-role-utils";
import { useHasUserValidFeatureCompanyLevel } from "@hooks/feature-control/use-has-user-valid-feature-company-level";
import { PALETTE_VARS } from "@styles/palette-vars";
/** The content for the dialog create team */
export function CreateTeamDialogContent(t0) {
  const $ = _c(50);
  const {
    state,
    dispatchTeams,
    isGroupRoleSelected,
    selectedMembers,
    autocompleteOptions,
    helperText,
    handleMemberSelect,
    onInputChange,
    isNewEmailValid
  } = t0;
  const {
    canAssignManagers
  } = useHasUserValidFeatureCompanyLevel();
  let t1;
  if ($[0] !== dispatchTeams) {
    t1 = function resetGroupsState() {
      dispatchTeams({
        type: "SET_SELECTED_GROUP_ID",
        selectedGroupId: ""
      });
      dispatchTeams({
        type: "SET_SELECTED_ROLE",
        selectedRole: undefined
      });
    };
    $[0] = dispatchTeams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const resetGroupsState = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      paddingX: "2px"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      alignItems: "center"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Grid size="grow"><Box sx={{
        borderBottom: `1px solid ${PALETTE_VARS.divider}`,
        width: "100%"
      }} /></Grid>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      mx: 2
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Grid><Box sx={t5}><SphereAvatar icon={<TeamIcon sx={{
          width: "40px",
          height: "40px"
        }} />} size="x-large" backgroundColor={TEAM_AVATAR_BACKGROUND} /></Box></Grid>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Grid container={true} sx={t3}>{t4}{t6}<Grid size="grow"><Box sx={{
          borderBottom: `1px solid ${PALETTE_VARS.divider}`,
          width: "100%"
        }} /></Grid></Grid>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Text variant="bodyM" component="div" sx={{
      marginY: "32px"
    }}>{capitalizeFirstLetter(TEAMS_DISPLAY_NAME)} allow you to organize individual members and assign roles to the entire {TEAM_DISPLAY_NAME} at once, saving time compared to assigning roles to each member individually.</Text>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <LabelWithHelp title={`${capitalizeFirstLetter(TEAM_DISPLAY_NAME)} name`} isRequired={true} />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== dispatchTeams) {
    t10 = name => {
      dispatchTeams({
        type: "SET_TEAM_NAME",
        teamName: name
      });
    };
    $[10] = dispatchTeams;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== state.teamName) {
    t11 = isValidTeamName(state.teamName) ? "" : `${capitalizeFirstLetter(TEAM_DISPLAY_NAME)} name shouldn't contain comma(,), semicolon(;) or pipeline(|).`;
    $[12] = state.teamName;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== state.teamName || $[15] !== t10 || $[16] !== t11) {
    t12 = <Stack sx={STACK_ERROR_SX}>{t9}<TextField maxCharacterCount={MAX_NAME_CHARACTERS} shouldShowCounter={true} onTextChanged={t10} text={state.teamName} fullWidth={true} placeholder={`Enter the ${TEAM_DISPLAY_NAME} name...`} autoFocus={true} error={t11} /></Stack>;
    $[14] = state.teamName;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  const t13 = state.selectedRole;
  let t14;
  if ($[18] !== dispatchTeams) {
    t14 = role => dispatchTeams({
      type: "SET_SELECTED_ROLE",
      selectedRole: role
    });
    $[18] = dispatchTeams;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== canAssignManagers) {
    t15 = getAssignableWorkspaceRoles("invite", canAssignManagers);
    $[20] = canAssignManagers;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== resetGroupsState || $[23] !== state.selectedRole || $[24] !== t14 || $[25] !== t15) {
    t16 = <Stack sx={STACK_ERROR_SX}><CompanyRoleAutoComplete selectedRole={t13} onChange={t14} placeholder="Assign a workspace role to your team if needed" onResetSelection={resetGroupsState} roles={t15} shouldAllowAllRolesSelection={true} /></Stack>;
    $[22] = resetGroupsState;
    $[23] = state.selectedRole;
    $[24] = t14;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== dispatchTeams || $[28] !== isGroupRoleSelected || $[29] !== state.selectedGroupId) {
    t17 = isGroupRoleSelected && <Stack sx={STACK_ERROR_SX}><LabelWithHelp title="Group" isRequired={true} /><GroupAutoComplete callbackOnGroupSelected={groupId => dispatchTeams({
        type: "SET_SELECTED_GROUP_ID",
        selectedGroupId: groupId
      })} selectedGroupId={state.selectedGroupId} placeholder="Please select a group..." /></Stack>;
    $[27] = dispatchTeams;
    $[28] = isGroupRoleSelected;
    $[29] = state.selectedGroupId;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== autocompleteOptions || $[32] !== handleMemberSelect || $[33] !== helperText || $[34] !== isNewEmailValid || $[35] !== onInputChange || $[36] !== selectedMembers) {
    t18 = <Stack sx={STACK_ERROR_SX}><MembersAutocomplete label="Members" selectedOptions={selectedMembers} options={autocompleteOptions} helperText={helperText} isValid={isNewEmailValid} handleMemberSelect={handleMemberSelect} onInputChange={onInputChange} placeHolder={EMAILS_ONLY_PLACEHOLDER} /></Stack>;
    $[31] = autocompleteOptions;
    $[32] = handleMemberSelect;
    $[33] = helperText;
    $[34] = isNewEmailValid;
    $[35] = onInputChange;
    $[36] = selectedMembers;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <LabelWithHelp title="Description" />;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== dispatchTeams) {
    t20 = description => {
      dispatchTeams({
        type: "SET_DESCRIPTION",
        description
      });
    };
    $[39] = dispatchTeams;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== state.description || $[42] !== t20) {
    t21 = <TextField maxCharacterCount={MAX_DESCRIPTION_CHARACTERS} shouldShowCounter={true} onTextChanged={t20} text={state.description} fullWidth={true} placeholder={`Enter the ${TEAM_DISPLAY_NAME} description...`} multiline={true} rows={4} />;
    $[41] = state.description;
    $[42] = t20;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t12 || $[45] !== t16 || $[46] !== t17 || $[47] !== t18 || $[48] !== t21) {
    t22 = <Grid sx={t2}>{t7}{t8}{t12}{t16}{t17}{t18}{t19}{t21}</Grid>;
    $[44] = t12;
    $[45] = t16;
    $[46] = t17;
    $[47] = t18;
    $[48] = t21;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  return t22;
}